import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconUsers } from '@tabler/icons-react';
import { lazy } from 'react';
import { isAdmin } from '@ayocore/platform/identity/client/guards';

/**
 * Бутстрап клиентской части модуля API Gateway.
 */
export async function setup(app: AppRuntime) {
  const gateway = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  gateway.useNavigation([
    {
      icon: IconUsers,
      label: 'Внешние пользователи',
      url: '/api-gateway/external-accounts',
      component: lazy(() =>
        import('./components/ExternalAccounts/ExternalAccountsList').then(m => ({
          default: m.ExternalAccountsList,
        }))
      ),
      guard: isAdmin,
    },
  ]);
}
